import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const Documents = ({ listData }) => {
  const style = {
    fontFamily: "sans-serif",
    paddingTop: "10px",
    // whiteSpace: "nowrap",
  };

  return (
    <>
      {listData.allowed ? (
        <Col>
          <CardTitle style={{ color: "#3498db" }}>{listData.title}</CardTitle>
          <Card className="mini-stats-wid">
            <CardBody>
              <Row style={{ justifyContent: "space-between" }}>
                {listData.data.length > 0 ? (
                  listData.data.map(
                    (
                      item,
                      index // Ajout de l'argument index pour suivre l'index de l'élément
                    ) => (
                      <Row
                        key={item.id}
                        style={{
                          borderBottom:
                            index !== listData.data.length - 1
                              ? "1px solid #eee"
                              : "none", // Applique la bordure sauf pour la dernière ligne
                          marginLeft: "-1px",
                        }}
                      >
                        <Col xs={2}>
                          <a
                            href={item.link}
                            className="text-dark"
                            style={{ textDecoration: "none", display: "block" }}
                            download
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                padding: "10px 0",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <div
                                className="avatar-sm"
                                style={{ display: "inline-block" }}
                              >
                                <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                  <i className="bx bxs-file-doc" />
                                </span>
                              </div>
                            </div>
                          </a>
                        </Col>
                        <Col xs={8}>
                          <a
                            href={item.link}
                            className="text-dark"
                            style={{ textDecoration: "none", display: "block" }}
                            download
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                padding: "10px 0",
                                // whiteSpace: "nowrap",
                              }}
                            >
                              <div
                                style={{
                                  ...style,
                                  paddingLeft: "10px",
                                  display: "inline-block",
                                  verticalAlign: "top",
                                }}
                              >
                                <h5 className="font-size-13 mb-1">
                                  {item.nom}
                                </h5>
                              </div>
                            </div>
                          </a>
                        </Col>
                        <Col xs={2}>
                          <div
                            className="d-flex justify-content-end align-items-center"
                            style={{ display: "inline-block" }}
                          >
                            <a
                              href={item.link}
                              className="text-dark"
                              style={{
                                textDecoration: "none",
                                display: "inline-block",
                              }}
                              download
                            >
                              <i
                                className="bx bx-download h2 m-2"
                                style={{ fontSize: "1.8rem" }}
                              />
                            </a>
                          </div>
                        </Col>
                      </Row>
                    )
                  )
                ) : (
                  <Col
                    xs={12}
                    style={{ textAlign: "center", padding: "20px 0" }}
                  >
                    Aucune donnée disponible
                  </Col>
                )}
              </Row>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Documents;
